import { gql } from "lib/apolloClient";
import {
  attachmentFragment,
  staffFragment,
  courseFragment,
  studentsAlertFragment,
  academicYearFragment,
} from "modules/CommonFragments";
import { studentInfofragment } from "StudentPortfolio/routes/PortfolioDetailsV2/modules/ProfileDetailsFragments";

export const studentNoteCategoryFragment = {
  studentNoteCategory: gql`
    fragment studentNoteCategoryItem on StudentNoteCategory {
      id
      value
      metadata
    }
  `,
};

export const studentProfileQuestionFragment = {
  studentProfileQuestion: gql`
    fragment studentProfileQuestionItem on StudentProfileQuestion {
      id
      title
    }
  `,
};

export const studentProfileSectionFragment = {
  studentProfileSection: gql`
    fragment studentProfileSectionItem on StudentProfileSection {
      id
      title
      studentProfileQuestions {
        ...studentProfileQuestionItem
      }
    }
    ${studentProfileQuestionFragment.studentProfileQuestion}
  `,
};

export const studentNoteFragment = {
  studentNote: gql`
    fragment studentNoteItem on StudentNote {
      id
      title
      category {
        ...studentNoteCategoryItem
      }
      description
      createdBy {
        ...staffItem
      }
      createdAt
      updatedAt
      attachments {
        ...attachmentItem
      }
    }
    ${staffFragment.basicStaffDetails}
    ${attachmentFragment.attachment}
    ${studentNoteCategoryFragment.studentNoteCategory}
  `,
};

export const studentProfileResponseFragment = {
  studentProfileResponse: gql`
    fragment studentProfileResponseItem on StudentProfileResponse {
      id
      title
      studentProfileQuestion {
        id
      }
      createdBy {
        ...staffItem
      }
      createdAt
      attachments {
        ...attachmentBasicDetailsItem
        mimeType
      }
    }
    ${staffFragment.basicStaffDetails}
    ${attachmentFragment.basicDetails}
  `,
};

export const studentDetailsFragment = {
  studentNotes: gql`
    fragment studentNotesItem on Student {
      id
      studentNotes {
        ...studentNoteItem
      }
    }
    ${studentNoteFragment.studentNote}
  `,
  studentBasicDetails: gql`
    fragment studentBasicDetailsItem on Student {
      id
      sourceId
      firstName
      middleName
      lastName
      preferredName
      suffix
      pronouns
      gender
      type
      profileImage
      email
    }
  `,
  studentDetails: gql`
    fragment studentDetailsItem on Student {
      id
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      gender
      type
      profileImage
      email
      isArchived
      isArchivedV2(filters: $userArchivedFilters)
      familyInviteCode
      parentStatus
      signInCode
      sourceId
      alertTypes {
        ...alertTypeFields
      }
      ...studentAdditionalInfoItem
      courses(orderBy: TITLE, orderByDirection: ASC, filters: $courseFilters) {
        ...courseItem
      }
      families {
        id
      }
      projectGroups(
        filters: {
          projectGroupSubTypes: [CORE, INTERNAL_ASSESSMENT, EXTERNAL_ASSESSMENT]
        }
      ) {
        id
        projects(filters: { students: [$studentId] }) {
          edges {
            node {
              id
              reportStatus
            }
          }
        }
        type
      }
      studentProjectPortfolios {
        id
        isComplete
        projectGroup {
          id
          name
        }
      }
      otherDetails {
        id
      }
    }
    ${studentsAlertFragment}
    ${courseFragment.basicCourserDetails}
    ${studentInfofragment.additionalInfo}
  `,
  studentProfileResponses: gql`
    fragment studentProfileResponsesItem on Student {
      id
      studentProfileResponses {
        ...studentProfileResponseItem
      }
    }

    ${studentProfileResponseFragment.studentProfileResponse}
  `,
  familyInfo: gql`
    fragment familyInfo on FamilyMember {
      id
      firstName
      middleName
      lastName
      prefix
      suffix
      preferredName
      pronouns
      email
      status
      isCreatedByOrg
    }
  `,
};

export const organizationFragment = {
  studentNoteCategory: gql`
    fragment organizationItem on Organization {
      id
      constants {
        studentNoteCategory {
          ...studentNoteCategoryItem
        }
      }
    }
    ${studentNoteCategoryFragment.studentNoteCategory}
  `,
  studentProfileSections: gql`
    fragment organizationItem on Organization {
      id
      studentProfileSections(filters: $filters) {
        ...studentProfileSectionItem
      }
    }
    ${studentProfileSectionFragment.studentProfileSection}
  `,
};

export const personalContactsFragment = {
  personalContacts: gql`
    fragment personalContactsItem on PersonalContact {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      secondPhoneNumber
      thirdPhoneNumber
      relationship
    }
  `,
};

export const addressFragment = {
  address: gql`
    fragment addressItem on Address {
      id
      line1
      line2
      city
      state
      zipcode
      country
    }
  `,
};

export const otherDetailsFragment = {
  otherDetails: gql`
    fragment otherDetailsItem on OtherUserDetails {
      id
      dob
      primaryNationality
      secondaryNationality
      languages
      birthPlace
      nationalId
      firstNameLocale
      lastNameLocale
      dobLocale
      birthPlaceLocale
      primaryNationalityLocale
      religionLocale
      pronouns
      seventhAdditionalField
      eighthAdditionalField
    }
  `,
};

export const studentOtherDetailsFragment = {
  studentOtherDetails: gql`
    fragment studentOtherDetailsItem on Student {
      id
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      type
      gender
      email
      sourceId
      profileImage
      enrollmentDate
      withdrawalDate
      yearGroup {
        id
        name
        grade {
          id
          name
        }
      }
      personalContacts {
        ...personalContactsItem
      }
      address {
        ...addressItem
      }
      otherDetails {
        ...otherDetailsItem
      }
      academicYears {
        ...academicYearItem
      }
    }
    ${personalContactsFragment.personalContacts}
    ${addressFragment.address}
    ${otherDetailsFragment.otherDetails}
    ${academicYearFragment.academicYear}
  `,
};
